import styled from 'styled-components'
import colors from '../../styles/colors'
import { SERVICE_HEALTH } from '../../store/models/status'

const HEALTH_COLOR = {
  [SERVICE_HEALTH.OPERATIONAL]: colors.green_full,
  [SERVICE_HEALTH.DEGRADED]: colors.amber_warning,
  [SERVICE_HEALTH.DOWN]: colors.red_critical
}

export const Card = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  margin-left: auto;
  overflow: hidden;
  width: 50%;
`

export const Header = styled.div`
  align-items: center;
  background-color: ${({ health }) => HEALTH_COLOR[health] || colors.red_critical};
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 6px 12px;
`

export const Body = styled.div`
  background-color: ${({ theme }) => theme.palette.brand.gray[95]};
  padding: 4px 12px;
  text-align: center;
`
